/* eslint-disable no-underscore-dangle */
import { compact, filter, flatMap, flow, map, split } from 'lodash/fp';

import { PortableTextType } from '../../../../types/sanityInternal';

const WPM = 225;

const getReadTime = (bodyRaw: PortableTextType[]) => {
  const wordsCombined = flow(
    filter((block: PortableTextType) => block._type === 'block'),
    map((block) => map((innerBlock) => innerBlock.text, block.children)),
    flatMap((block) => block),
    flatMap(split(' ')),
    compact,
  )(bodyRaw);
  const copyLength = wordsCombined.length;
  return Math.ceil(copyLength / WPM);
};

export default getReadTime;
